import React from 'react';
import { Form, Input, Radio, Space } from 'antd';

export const staticQuestions = [
  {
    questionText: "How satisfied are you with the overall webinar experience? Rate the content quality, speaker expertise, and platform performance on a scale of 1–5.",
    questionType: "BOOLEAN_RADIO",
    options: ["Yes", "No"],
  },
  {
    questionText: "Which session topic was most relevant to your current business needs — AI in ERP, demand forecasting, adaptive scheduling, or connected factory strategy?",
    questionType: "TEXT_INPUT",
  },
  {
    questionText: "Would you be interested in a follow-up consultation with one of our specialists to explore how these solutions apply to your environment?",
    questionType: "BOOLEAN_RADIO",
    options: ["Yes", "No"],
  },
  {
    questionText: "How likely are you to attend future TechDogs webinars? Your response helps us understand audience loyalty and plan upcoming programming.",
    questionType: "BOOLEAN_RADIO",
    options: ["Yes", "No"],
  },
  {
    questionText: "What additional topics would you like us to cover in future sessions? Open-ended responses surface the highest-priority themes for your audience.",
    questionType: "TEXT_INPUT",
  }
];

const InteractiveSurveyQuestion: React.FC = () => {
  return (
    <div className="interactive-form-section" style={{ marginTop: '20px', marginBottom: '20px', textAlign: 'left' }}>
      {staticQuestions.map((q, index) => (
        <div key={index} style={{ marginBottom: '20px' }}>
          <Form.Item
            label={
              <span>
                {index + 1}. {q.questionText}
              </span>
            }
            name={['interactive', index]}
            style={{ marginBottom: '8px' }}
          >
            {q.questionType === 'TEXT_INPUT' && (
              <Input placeholder="Type your answer here..." />
            )}
            
            {q.questionType === 'BOOLEAN_RADIO' && (
              <Radio.Group>
                <Space direction="vertical" style={{ marginTop: '10px' }}>
                  {(q.options || []).map((opt: string, i: number) => (
                    <Radio key={i} value={opt}>{opt}</Radio>
                  ))}
                </Space>
              </Radio.Group>
            )}
          </Form.Item>
        </div>
      ))}
    </div>
  );
};

export default InteractiveSurveyQuestion;